function insertSpaceBeforeCapitals(str: string): string {
  return str.replace(/([a-z])([A-Z])/g, '$1 $2');
}

function addSpacesAroundSlashes(str: string): string {
  return str.replace(/\//g, ' / ');
}

export function formatString(input: string): string {
  const withSpaces = insertSpaceBeforeCapitals(input);
  return addSpacesAroundSlashes(withSpaces);
}
